/** Stable per-grid layout ids persisted on User.gridLayouts. */
export const GRID_LAYOUT_KEYS = {
    catalogItems: "catalogItems",
    printLabels: "printLabels",
    invoices: "invoices",
    products: "products",
    orders: "orders",
    fulfillment: "fulfillment",
    shipments: "shipments",
    returns: "returns",
    buyerView: "buyerView",
    inventoryLevels: "inventoryLevels",
    dimensions: "dimensions",
    orderGrid: "orderGrid",
    userBase: "userBase",
};

/** One layout key per dimension/attribute table (brands, sizes, variants, …). */
export function dimensionLayoutKey(spec) {
    const raw = String(spec?.endpoint || spec?.title || "dimensions")
        .replace(/[^a-zA-Z0-9_-]/g, "_")
        .slice(0, 48);
    return `dimensions_${raw || "table"}`;
}
